import useAppStateStore from "../../../shared/store/AppStateStore";
import SupportStep from "../enums/SupportStep";
import useSupportStore from "../store/supportStore";
import { scrollToTop } from "../../../shared/utils/scrollUtils";
import { postCase } from "../services/supportService";

export const handleSupportPrevious = () => {
  const STATE = useAppStateStore.getState();
  const selectedOptions = Array.isArray(STATE.selectedOptions)
    ? STATE.selectedOptions
    : [];
  const spCurrentStep = STATE.spCurrentStep;
  const currentIndex = selectedOptions.findIndex(
    (step) => step.id === spCurrentStep
  );

  if (currentIndex > 0) {
    STATE.setSpCurrentStep(selectedOptions[currentIndex - 1].id);
  } else {
    STATE.setSpCurrentStep(SupportStep.SP1);
  }
  scrollToTop();
};

export const handleSupportNext = async (navigate) => {
  const STATE = useAppStateStore.getState();
  const selectedOptions = Array.isArray(STATE.selectedOptions)
    ? STATE.selectedOptions
    : [];
  const spCurrentStep = STATE.spCurrentStep;
  const currentIndex = selectedOptions.findIndex(
    (step) => step.id === spCurrentStep
  );
  if (currentIndex < selectedOptions.length - 1) {
    STATE.setSpCurrentStep(selectedOptions[currentIndex + 1].id);
  } else if (spCurrentStep === SupportStep.SP_CANCELLATION) {
    STATE.setIsCancellationModalOpen(true);
  } else {
    STATE.setIsChangeModalOpen(true);
  }
  scrollToTop();
};

export const submitSupportCase = async (navigate) => {
  const STATE = useAppStateStore.getState();
  STATE.setSupportLoading(true);
  const supportStore = useSupportStore.getState();
  const requestBody = supportStore.Payload;
  await postCase({ requestBody, navigate });
  STATE.setSupportLoading(false);
  STATE.setSpCurrentStep(SupportStep.SP_COMPLETE);
};

export const updateSupportType = () => {
  const STATE = useAppStateStore.getState();
  const store = useSupportStore.getState();
  const selectedOptions = Array.isArray(STATE.selectedOptions)
    ? STATE.selectedOptions
    : [];
  if (selectedOptions.some((step) => step.id === SupportStep.SP_CANCELLATION)) {
    store.updateField("Reason_for_case__c", "Cancel Policy");
    store.updateField("Type", "Cancel and Existing Policy");
  } else {
    store.updateField("Reason_for_case__c", "Make a change to my policy");
    store.updateField("Type", "Customer Care");
  }
};
